import { render, staticRenderFns } from "./head.vue?vue&type=template&id=5db1b441&scoped=true"
var script = {}
import style0 from "./head.vue?vue&type=style&index=0&id=5db1b441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1b441",
  null
  
)

export default component.exports